import type { FC } from 'react'
import { createContext, useState, useContext } from 'react'

interface CartModalProps {
  cartModal: boolean
  toggleCartModal: () => void
}

const CartModalContext = createContext<CartModalProps>({
  cartModal: false,
  toggleCartModal: () => {},
})

export const CartModalProvider: FC = ({ children }) => {
  const { Provider } = CartModalContext
  const [cartModal, setCartModal] = useState<CartModalProps['cartModal']>(false)

  return (
    <Provider
      value={{
        cartModal,
        toggleCartModal: () => setCartModal(!cartModal),
      }}
    >
      {children}
    </Provider>
  )
}

export function useCartModal() {
  const { cartModal, toggleCartModal } = useContext(CartModalContext)
  return { cartModal, toggleCartModal }
}

export default useCartModal
